import { motion, useReducedMotion } from 'framer-motion';
import React from 'react';

/**
 * Reveal variants:
 *  - 'up' (default) — fade + slide up
 *  - 'left' — fade + slide from left
 *  - 'right' — fade + slide from right
 *  - 'scale' — fade + subtle scale
 *  - 'fade' — fade only
 */
export function Reveal({ children, delay = 0, variant = 'up', y = 16, className = '' }) {
  const reduce = useReducedMotion();

  const variants = {
    up:    { hidden: { opacity: 0, y }, show: { opacity: 1, y: 0 } },
    left:  { hidden: { opacity: 0, x: -24 }, show: { opacity: 1, x: 0 } },
    right: { hidden: { opacity: 0, x: 24 }, show: { opacity: 1, x: 0 } },
    scale: { hidden: { opacity: 0, scale: 0.96 }, show: { opacity: 1, scale: 1 } },
    fade:  { hidden: { opacity: 0 }, show: { opacity: 1 } },
  }[variant] || { hidden: { opacity: 0, y }, show: { opacity: 1, y: 0 } };

  return (
    <motion.div
      className={className}
      initial={reduce ? false : 'hidden'}
      whileInView={reduce ? {} : 'show'}
      viewport={{ once: true, margin: '-60px' }}
      variants={variants}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1], delay }}
    >
      {children}
    </motion.div>
  );
}

export default Reveal;
